import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid"
import { PropsWithChildren, ReactNode, forwardRef } from "react"
import { classNames } from "../../style/common"

export type AccordianProps = PropsWithChildren & {
    label: string | ReactNode,
    isOpen: boolean,
    onClick: () => void,
    className?: string | undefined,
    classNames?: {
        childrenContainer?: string | undefined
    }
}

export const Accordian = forwardRef<HTMLDivElement, AccordianProps>((props: AccordianProps, ref) => {
    return (
        <div className={`divide-y select-none divide-color-border rounded-md bg-secondary overflow-hidden shadow text-contrast-primary border border-solid border-color-border/60 ${props.className ? ` ${props.className}` : ""}`}>
            <div className="px-3 py-3 sm:px-3 cursor-pointer flex justify-between hover:bg-tertiary" onClick={(event) => props.onClick()} ref={ref}>
                <h3 className=" text-sm font-semibold">{props.label}</h3>
                {
                    props.isOpen
                        ? <ChevronUpIcon className="h-5 w-5" aria-hidden="true" />
                        : <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
                }
            </div>
            <div className={
                classNames(
                    `${props.isOpen ? "block" : "hidden"}`,
                    props.classNames?.childrenContainer
                )
            }>
                {props.children}
            </div>
        </div >
    )
});